import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import StepProgress from '../Common/StepProgress/StepProgress';
// import { convertDateTime } from '../Util/DateTime';

import Hold from '../../assets/Hold.svg';
import Empty from '../../assets/Empty.svg';
import HoldWhite from '../../assets/HoldWhite.svg';
import Rejected from '../../assets/Rejected.svg';
import CircularCheck from '../../assets/CircularCheck.svg';

export interface Props {
  rtl: boolean;
}

function OrderStatus({ rtl }: Props) {
  const [orderData, setOrderData] = useState<any>(null);
  const [level, setLevel] = useState(0);
  const [srcType, setSrcType] = useState(Empty);
  const [status, setStatus] = useState('');
  const [statusClass, setStatusClass] = useState('');
  const [leadDate, setLeadDate] = useState('');
  const [opportunityDate, setOpportunityDate] = useState('');
  const [completedDate, setCompletedDate] = useState('');
  const [deliveryDate, setDeliveryDate] = useState('');
  const [reload, setReload] = useState(0);




  const { t } = useTranslation();
  const dir = rtl ? "right" : "left";
  function parseCustomDate(str: string): Date | null {
    if (!str) return null;

    try {
      const [datePart, timePart] = str.split('/');
      if (!datePart || !timePart) return null;

      const [day, month, year] = datePart.split('.').map(Number);
      let [time, ampm] = timePart.split(' ');
      let [hours, minutes] = time.split(':').map(Number);

      if (ampm === 'PM' && hours < 12) hours += 12;
      if (ampm === 'AM' && hours === 12) hours = 0;

      const fullYear = year < 100 ? 2000 + year : year;

      return new Date(fullYear, month - 1, day, hours, minutes);
    } catch {
      return null;
    }
  }
  function formatDateForConvert(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString().slice(-2);
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const time = `${hours.toString().padStart(2, '0')}:${minutes} ${ampm}`;
    return `${day}.${month}.${year}/${time}`;
  }
  function getAdjustedDate(rawDate: string, hoursToSubtract: number): string {
    if (!rawDate) return '';

    const date = parseCustomDate(rawDate);
    if (!date || isNaN(date.getTime())) return '';

    const adjusted = new Date(date.getTime() - hoursToSubtract * 60 * 60 * 1000);
    return formatDateForConvert(adjusted);
  }


  useEffect(() => {
    const data: any = JSON.parse(sessionStorage.getItem('OrderStatusValue'));
    setOrderData(data);



    const leadStatus = data.TUSER_STATUS_CODE;
    const opportunityPhase = data.TDSC_SALPHASE;
    const opportunityStatus = (data.TDOC_OPPLIFCYCST).toLowerCase();
    const leadDateRaw = data.Cs1ANsAF3C964C2847919;
    const opportunityDateRaw = data.Cs1ANs13D05C39131DB8A;
    setLeadDate(leadDateRaw);


    if (leadStatus !== 'Converted') {
      if (leadStatus === 'Credit Check') {
        setStatus(t('InProgress'));
        setStatusClass('In Progress');
        setSrcType(HoldWhite);
        setLeadDate(leadDateRaw);
        setLevel(0);
      }

      if (leadStatus === 'Rejected Credit Check') {
        setStatus(t('OnHold'));
        setStatusClass('On Hold');
        setSrcType(Hold);
        setLeadDate(leadDateRaw);
        setLevel(0);
      }

      if (leadStatus === 'Lost') {
        setStatus(t('Rejected'));
        setStatusClass('Rejected');
        setSrcType(Rejected);
        setLeadDate(leadDateRaw);
        setLevel(0);
      }


      if (leadStatus === 'Accepted Credit Check') {
        setStatus(t('InProgress'));
        setStatusClass('In Progress');
        setSrcType(CircularCheck);
        setLeadDate(leadDateRaw);
        setLevel(0);
      }
    }
    else {
      if (opportunityPhase === 'Return to Sales') {
        setStatus(t('OnHold'));
        setStatusClass('On Hold');
        setSrcType(Hold);
        setLeadDate(leadDateRaw);
        setOpportunityDate(opportunityDateRaw);
        if (opportunityStatus === 'dropped/cancelled') {
          setStatus(t('Closed'));
          setStatusClass('Closed');
          setSrcType(Rejected);
        }
        setLevel(1);
      }

      if (opportunityPhase === 'OMT Control') {
        setStatus(t('InProgress'));
        setStatusClass('In Progress');
        setSrcType(HoldWhite);
        setLeadDate(leadDateRaw);
        setOpportunityDate(opportunityDateRaw);
        if (opportunityStatus === 'dropped/cancelled') {
          setStatus(t('Closed'));
          setStatusClass('Closed');
          setSrcType(Rejected);
        }
        setLevel(1);
      }
      if (opportunityPhase === 'Supply Chain Store') {
        setStatus(t('InProgress'));
        setStatusClass('In Progress');
        setSrcType(HoldWhite);
        setLeadDate(leadDateRaw);
        setOpportunityDate(opportunityDateRaw);
        if (opportunityStatus === "dropped/cancelled") {
          setStatus(t('Closed'));
          setStatusClass('Closed');
          setSrcType(Rejected);
        }
        setLevel(1);

      }


      if (opportunityPhase === 'Order Creation') {
        const oppDateRaw = opportunityDateRaw;
        setStatus(t('InProgress'));
        setStatusClass('In Progress');
        setSrcType(HoldWhite);
        setLeadDate(leadDateRaw);
        setOpportunityDate(getAdjustedDate(oppDateRaw, 4));
        setCompletedDate(oppDateRaw);
        if (opportunityStatus === "dropped/cancelled") {
          setStatus(t('Closed'));
          setStatusClass('Closed');
          setSrcType(Rejected);
        }
        setLevel(2);
      }

      if (opportunityPhase === 'Order Completed') {
        const oppDateRaw = opportunityDateRaw;
        setStatus(t('Completed'));
        setStatusClass('Completed');
        setSrcType(CircularCheck);
        setLeadDate(leadDateRaw);
        setOpportunityDate(getAdjustedDate(oppDateRaw, 8));
        setCompletedDate(getAdjustedDate(oppDateRaw, 4));
        setDeliveryDate(oppDateRaw);
        setLevel(3);
      }
      if (opportunityPhase === 'WON') {
        const oppDateRaw = opportunityDateRaw
        setStatus(t('Completed'));
        setStatusClass('Completed');
        setSrcType(CircularCheck);
        setLeadDate(leadDateRaw);
        setOpportunityDate(getAdjustedDate(oppDateRaw, 8));
        setCompletedDate(getAdjustedDate(oppDateRaw, 4));
        setDeliveryDate(oppDateRaw);
        setLevel(3);
      }

      if (opportunityPhase === 'Supply Chain Delivery') {
        const oppDateRaw = opportunityDateRaw;
        setStatus(t('OutForDelivery'));
        setStatusClass('Out for Delivery');
        setSrcType(HoldWhite);
        setLeadDate(leadDateRaw);
        setOpportunityDate(getAdjustedDate(oppDateRaw, 8));
        setCompletedDate(getAdjustedDate(oppDateRaw, 4));
        setDeliveryDate(oppDateRaw);
        setLevel(3);

      }
      if (opportunityPhase === 'Documentation Collection') {
        setStatus(t('Completed'));
        setStatusClass('Completed');
        setSrcType(CircularCheck);
        setLeadDate(leadDateRaw);
        setDeliveryDate(opportunityDateRaw);
        setOpportunityDate(opportunityDateRaw);

        setLevel(3);
      }
      if (opportunityPhase === 'Finger Print') {
        setStatus(t('InProgress'));
        setStatusClass('In Progress');
        setSrcType(HoldWhite);
        setLeadDate(leadDateRaw);
        setOpportunityDate(opportunityDateRaw);
        if (opportunityStatus === "dropped/cancelled") {
          setStatus(t('Closed'));
          setStatusClass('Closed');
          setSrcType(Rejected);
        }
        setLevel(2);
      }
      if (opportunityPhase === 'Not Assigned' || !opportunityPhase) {
        setStatus(t('InProgress'));
        setStatusClass('In Progress');
        setSrcType(HoldWhite);
        setLeadDate(leadDateRaw);
        setLevel(1);
      }
    }
  }, [t]);


  const steps = [
    {
      label: t("Credit_Check"),
      date: leadDate,
      srcImg: level > 0 ? CircularCheck :  level === 0 ? srcType : Empty,
      completed: level >= 0 ? true : false,
      type: level >= 0 ? 'not-empty' : 'empty'
    },
    {
      label: t("Info_Verify"),
      date: opportunityDate,
      srcImg: level > 1 ? CircularCheck : level === 1 ? srcType : Empty,
      completed: level >= 1 ? true : false,
      type: level >= 1 ? 'not-empty' : 'empty'
    },
    {
      label: t("Order_Creation"),
      date: completedDate,
      srcImg: level > 2 ? CircularCheck : level === 2 ? srcType : Empty,
      completed: level >= 2,
      type: level >= 2 ? 'not-empty' : 'empty'
    },
    {
      label: t("Delivery"),
      date: deliveryDate,
      srcImg: level === 3 ? srcType : Empty,
      completed: level === 3,
      type: level === 3 ? 'not-empty' : 'empty',
    }
  ]
  const subClass = statusClass.split(' ').join('').toLowerCase();


  return (
    <div className="container">
      <div className="row">
        {orderData && (
          <div className="col-sm-12 orderStatus-container">
            <Typography className={`orderStatus-title arabicBold-${dir}`} rtl={rtl}>
              {t("Order")}
              <Typography className='orderId-withoutRtl'>#{orderData?.CDOC_ID}</Typography>
              {t("Status")}:<span className={`${subClass} order-status`}>{status}</span>
            </Typography>

            <div className={`orderStatus-step sansFont group-${dir}`}>
              <StepProgress rtl={rtl} steps={steps} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default OrderStatus;